import axios from "../axiosApi";
import { FETCH_USERS, RECEIVE_USERS, SAVE_USER, SAVE_USER_SUCCESS, DELETE_USER, DELETE_USER_SUCCESS } from "../actionTypes";

export const getUsers = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_USERS });
        try {
            const mappingFilter = JSON.stringify({ include: "role" });
            const [usersResp, mappingsResp] = await Promise.all([
                axios.get('/FermiUsers'),
                axios.get(`/RoleMappings?filter=${encodeURIComponent(mappingFilter)}`)
            ]);

            // Merge role name from RoleMapping into each user
            const users = usersResp.data.map((user: any) => {
                const mapping = mappingsResp.data.find(
                    (m: any) => String(m.principalId) === String(user.id) && m.principalType === "USER"
                );
                return { ...user, role: mapping?.role?.name || '' };
            });

            dispatch({ type: RECEIVE_USERS, payload: users });
        } catch (e) {
            console.error("getUsers ERROR", e);
            dispatch({ type: RECEIVE_USERS, payload: [] });
        }
    }
}

// Role name → Role.id mapping (from Role table)
const ROLE_IDS: Record<string, number> = {
    aluno: 1,
    professor: 2,
    secretaria: 3,
    coordenacao: 4,
    admin: 5,
    financeiro: 6,
    diretoria: 7,
    conselho: 8,
    'sem acesso': 9,
};

const updateUserRole = async (userId: number, roleName: string) => {
    const roleId = ROLE_IDS[roleName];
    if (!roleId) {
        console.error("updateUserRole: role not found:", roleName);
        return;
    }

    // Check if user already has a RoleMapping
    const mappingFilter = JSON.stringify({ where: { principalId: String(userId), principalType: "USER" } });
    const existingMappings = await axios.get(`/RoleMappings?filter=${encodeURIComponent(mappingFilter)}`);

    if (existingMappings.data.length > 0) {
        // Update existing RoleMapping
        const mappingId = existingMappings.data[0].id;
        await axios.patch(`/RoleMappings/${mappingId}`, { roleId });
    } else {
        // Create new RoleMapping
        await axios.post('/RoleMappings', {
            principalType: "USER",
            principalId: String(userId),
            roleId: roleId
        });
    }
}

export const saveUser = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_USER });
        try {
            const roleName = data.role;
            const userId = data.id;

            // Separate role from user data — role is managed via RoleMapping
            const userData = { ...data };
            delete userData.role;

            let response;
            if (userId) {
                delete userData.id;
                response = await axios.patch(`/FermiUsers/${userId}`, userData);
            } else {
                if (userData.id === null) delete userData.id;
                response = await axios.post('/FermiUsers', userData);
            }

            const savedUserId = userId || response.data.id;

            // Update RoleMapping
            if (roleName && savedUserId) {
                await updateUserRole(savedUserId, roleName);
            }

            dispatch({ type: SAVE_USER_SUCCESS, payload: response.data });
            dispatch(getUsers());
        } catch (e) {
            console.error("saveUser ERROR", e);
            dispatch({ type: SAVE_USER_SUCCESS, payload: { error: true } });
        }
    }
}

export const deleteUser = (id: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_USER });
        try {
            await axios.delete(`/FermiUsers/${id}`);
            dispatch({ type: DELETE_USER_SUCCESS });
            dispatch(getUsers());
        } catch (e) {
            console.error("deleteUser ERROR", e);
        }
    }
}
